<template>
  <div class="box" :style="`background-color: ${background}; max-width: ${maxWidth}; border-color: ${borderColor}; padding: ${padding}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Box",
  props: {
    background: {
      type: String,
      default: "#fff",
    },
    borderColor: {
      type: String,
      default: "#CDCDCD",
    },
    padding: {
      type: String,
      default: "1em",
    },
    maxWidth: {
      type: String,
      default: '768px'
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  border-width: 1px;
  border-style: solid;
  display: block;
}
</style>
